import { usePublishedBoxStore, publishQueries } from '@/entities/sets/publish';
import { useCommonStore, usePersistStore } from '@/shared/lib/store';
import { NoDataNew } from '@/shared/ui/no-data';
import { ByNicknameFilter } from '@/widgets/filter';
import { ByNicknameTable } from '@/widgets/table-list';
import { useQueryClient } from '@tanstack/react-query';
import moment from 'moment';
import { useMemo } from 'react';

export const ByNicknameTab = () => {
    const queryClient = useQueryClient();
    const { sUserId } = usePersistStore();
    const {
        searchKeyword,
        searchPage,
        setSearchPage,
        nickPublishState,
        startDate,
        endDate,
        dateTab,
        setNickPublishState,
        setStartDate,
        setEndDate,
        setDateTab,
        setResetTab,
    } = usePublishedBoxStore();
    // const [publishState, setPublishState] = useState<number[]>([2, 3]);
    // const [startDate, setStartDate] = useState<Date>();
    // const [endDate, setEndDate] = useState<Date>();
    // const [dateTab, setDateTab] = useState<string | undefined>('3');
    const { prevPath } = useCommonStore();
    const startFrom = startDate ? moment(startDate).format('YYYY-MM-DD') : undefined;
    const endTo = endDate ? moment(endDate).format('YYYY-MM-DD') : undefined;

    const queryParams = useMemo(
        () => ({
            wrterId: sUserId,
            nickNm: searchKeyword,
            sttsCds: nickPublishState.join(','),
            dateFrom: startFrom,
            dateTo: endTo,
            page: searchPage,
            size: 10,
        }),
        [sUserId, searchKeyword, nickPublishState, endDate, startDate, searchPage]
    );

    const { data, isFetched } = publishQueries.list.getPublishNickList(
        queryParams,
        !!startFrom && !!endTo
    );

    return (
        <>
            <ByNicknameFilter
                startDate={startDate}
                endDate={endDate}
                dateTab={dateTab}
                publishState={nickPublishState}
                setPublishState={setNickPublishState}
                setStartDate={setStartDate}
                setEndDate={setEndDate}
                setDateTab={setDateTab}
            />
            {data && data?.publishList?.length > 0 ? (
                <ByNicknameTable data={data} />
            ) : (
                isFetched && (
                    <NoDataNew
                        titleBlue={searchKeyword}
                        titleBlack="검색 결과가 없습니다."
                        type={'keyword'}
                    />
                )
            )}
        </>
    );
};
